module.exports = __webpack_public_path__ + "img/c10-m.ab53a3e0.jpg";